import { render, staticRenderFns } from "./deducList.vue?vue&type=template&id=55627c49&scoped=true"
import script from "./deducList.vue?vue&type=script&lang=js"
export * from "./deducList.vue?vue&type=script&lang=js"
import style0 from "./deducList.vue?vue&type=style&index=0&id=55627c49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55627c49",
  null
  
)

export default component.exports